import Box from "ds/components/Box";
import Link from "ds/components/Link";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";

import { CellComponentProps } from "../types";

type IdpGroupUsersListItemNameCellProps = CellComponentProps;

const IdpGroupUsersListItemNameCell = ({ user }: IdpGroupUsersListItemNameCellProps) => {
  const userUrl = `/settings/user/${user.id}`;

  return (
    <Box fullWidth gap="large">
      <Link
        analyticsPage={AnalyticsPageOrganization.OrganizationIdpGroupUsers}
        analyticsTitle="User Name Clicked"
        size="small"
        variant="secondary"
        href={userUrl}
      >
        {user.username}
      </Link>
    </Box>
  );
};

export default IdpGroupUsersListItemNameCell;
